import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloatButton from '@/components/WhatsAppFloatButton';
import GridBackground from '@/components/GridBackground';
import SEO from '@/components/SEO';
import ContactSection from '@/components/ContactSection';

export default function Partners() {
  return (
    <div className="relative min-h-screen bg-background overflow-hidden">
      <SEO
        fullTitle="Partnerships & Investment | Jotunheims"
        description="Explore strategic partnerships and investment opportunities across Jotunheims' AI, cybersecurity, fintech and green-tech ventures from Dubai."
        path="/partners"
        structuredData={{ '@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://jotunheims.com' },
          { '@type': 'ListItem', position: 2, name: 'Partnerships & Investment', item: 'https://jotunheims.com/partners' }
        ] }} />
      <GridBackground />
      <Navbar />
      <main className="relative z-10 pt-36">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-inter font-bold tracking-tight text-foreground mb-4">Partnerships &amp; Investment</h1>
          <p className="text-muted-foreground font-inter">
            Jotunheims welcomes strategic partnerships and investment in its ventures. 49 Option takes strategic stakes in startups.
          </p>
        </div>
        <ContactSection variant="partners" />
      </main>
      <Footer />
      <WhatsAppFloatButton />
    </div>
  );
}